/**
 * Basket availability — how many whole copies of a basket the farm's ingredient
 * stock can still build. The API sends it as `availableQuantity` on BasketDto.
 *
 * `null` means unconstrained, not sold out: a basket with no ingredients has no
 * cap, and a cart item restored from localStorage carries no availability until
 * the catalogue is refetched. Treating null as 0 would empty a healthy cart.
 */
export const LOW_AVAILABILITY_THRESHOLD = 5;

/** Reads `availableQuantity` off a basket/cart item as a non-negative int, or null. */
export const readAvailability = (source) => {
  const raw = source?.availableQuantity;
  if (raw === null || raw === undefined) return null;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return null;
  return Math.max(0, Math.trunc(parsed));
};

export const isSoldOut = (available) => available === 0;

/** Worth warning about on a card — scarce, but still buyable. */
export const isLowAvailability = (available) =>
  available !== null && available > 0 && available <= LOW_AVAILABILITY_THRESHOLD;

/** Caps a requested quantity at what the farm can build. Returns 0 when sold out. */
export const capQuantity = (quantity, available) => {
  const requested = Math.max(1, Math.trunc(Number(quantity) || 1));
  if (available === null) return requested;
  return Math.min(requested, available);
};
